'use strict';

export default (cinemaDom) => {

    const cinemaView = {};

    cinemaView.registerResizeHandler = (handler) => {
        window.addEventListener('resize', handler);
    };

    cinemaView.getTrackingData = () => {
        return JSON.parse(cinemaDom.getAttribute('data-tracking'));
    };

    return cinemaView;
};
